__turbopack_context__.v({
  "fieldset": "filterset-module-scss-module__u7O5eG__fieldset",
  "filterSet": "filterset-module-scss-module__u7O5eG__filterSet",
  "label": "filterset-module-scss-module__u7O5eG__label",
  "wrap": "filterset-module-scss-module__u7O5eG__wrap",
  "wrapper": "filterset-module-scss-module__u7O5eG__wrapper",
});
